import { useQuery } from "@apollo/client";
import { Table, Spin } from "antd";

import EdgeStateStatus from "../../components/EdgeStateStatus/EdgeStateStatus";
import NavigateButton from "../../components/NavigateButton";
import { AssetsDocument } from "../../graphql/graphql";

interface AssetTableProps {
  factoryId: string;
}

interface AssetRecord {
  id: string;
  key: string;
  name: string;
  functionalGroup: string;
  status: string;
}

const AssetTable = ({ factoryId }: AssetTableProps) => {
  const { data, loading } = useQuery(AssetsDocument, {
    skip: !factoryId,
    variables: { id: factoryId },
  });

  const assets =
    data?.factory.__typename === "QueryFactorySuccess"
      ? data.factory.data.assets
      : [];

  const dataSource = assets.map((asset) => ({
    id: asset.id,
    key: asset.id,
    name: asset.name,
    functionalGroup: asset.functionalGroup,
    status: "EdgeStateStatus",
  }));

  const columns = [
    {
      title: "Asset",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Functional Group",
      dataIndex: "functionalGroup",
      key: "functionalGroup",
    },
    {
      title: "Status",
      key: "status",
      render: (record: AssetRecord) => (
        <EdgeStateStatus assetId={record.id} statusOnly={true} />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record: AssetRecord) => (
        <NavigateButton
          name="Show"
          targetPath={`/dashboard/factory/${factoryId}/asset`}
          id={record.key}
        />
      ),
    },
  ];

  if (loading)
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Spin />
      </div>
    );

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
    />
  );
};

export default AssetTable;
